import { useEffect, useState } from "react";
import QRCode from "qrcode";
import { Button } from "@/components/ui/button";
import { Download } from "lucide-react";

const QRS = [
  { key: "menu", title: "QR Menù", desc: "Apre direttamente il menù digitale.", path: "/menu" },
  { key: "recensione", title: "QR Recensione", desc: "Porta alla pagina per la recensione Google.", path: "/recensione" },
  { key: "masetti", title: "QR Masetti", desc: "Landing con menù, prenota, eventi, recensione, Instagram e indicazioni.", path: "/masetti" },
];

function QRItem({ qr, origin }) {
  const [preview, setPreview] = useState("");
  const url = `${origin}${qr.path}`;
  useEffect(() => {
    QRCode.toDataURL(url, { width: 320, margin: 2, color: { dark: "#3D2314", light: "#FDFBF7" } }).then(setPreview).catch(() => {});
  }, [url]);

  const download = async () => {
    const hi = await QRCode.toDataURL(url, { width: 1600, margin: 3, color: { dark: "#3D2314", light: "#FDFBF7" } });
    const a = document.createElement("a"); a.href = hi; a.download = `qr-masetti-${qr.key}.png`; a.click();
  };

  return (
    <div className="bg-white rounded-xl border border-brass/15 p-5 text-center" data-testid={`qr-${qr.key}`}>
      <h3 className="font-serif text-lg text-bordeaux">{qr.title}</h3>
      <p className="text-xs text-oak/60 mt-1 mb-3 min-h-[32px]">{qr.desc}</p>
      {preview && <img src={preview} alt={qr.title} className="w-40 h-40 mx-auto rounded-lg border border-brass/20" />}
      <p className="text-[11px] text-oak/40 mt-2 break-all">{url}</p>
      <Button onClick={download} className="bg-brass hover:bg-brass-hover text-oak-dark mt-3 w-full" data-testid={`qr-download-${qr.key}`}><Download className="w-4 h-4 mr-2" />Scarica alta qualità</Button>
    </div>
  );
}

export default function QRView() {
  const origin = window.location.origin;
  return (
    <div>
      <h2 className="font-serif text-2xl text-bordeaux mb-1">QR Code</h2>
      <p className="text-sm text-oak/60 mb-4">Scarica i QR in alta qualità per tavoli, menu, biglietti e locandine.</p>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {QRS.map((qr) => <QRItem key={qr.key} qr={qr} origin={origin} />)}
      </div>
    </div>
  );
}
